// Which SOWs a purchase order appears to touch, and whether that is more than one.
//
// A PO covers one SOW. Raising one that spans several is refused now, but the POs
// raised before that rule still exist and are not obvious to spot: the PO's own
// SOW field was left empty and the only trace is the note the create path wrote,
// "Covers: AV-403045, AV-403067, No SOW". Goods bought on such a PO inherit no
// SOW, so they arrive in unallocated stock and have to be allocated by hand.

// A SOW reference is AV- followed straight by digits (AV-403045). PO numbers
// (AV-PO-502160), bid references (AV-BD-1042) and asset tags (AV-INV-05361) all
// have a letter after the dash, so they are not matched.
const SOW_REF = /\bAV-\d{4,}\b/g;

// Every distinct SOW reference mentioned in a piece of text, in the order they
// first appear. Safe on null, empty and non-string input.
export function sowRefsInText(text) {
  if (!text || typeof text !== 'string') return [];
  return [...new Set(text.match(SOW_REF) || [])];
}

// Work out the SOWs a PO touches from all three records of it, because none is
// reliable alone:
//   1. the PO's own SOW, which a historic combined PO does not have;
//   2. the SOWs of the hardware requests it was raised from, which is structured
//      data and so the one to trust;
//   3. SOW references in the notes, which is prose, but on an older PO whose
//      requests have since been edited it may be the only record left.
// Returns { spans, refs } — refs sorted, so the warning reads the same each time.
export function poSowSpread(po) {
  if (!po) return { spans: false, refs: [] };
  const refs = new Set();
  if (po.sow_reference) refs.add(po.sow_reference);
  for (const hr of po.hardware_requests || []) {
    if (hr?.sow_reference) refs.add(hr.sow_reference);
  }
  for (const ref of sowRefsInText(po.notes)) refs.add(ref);
  const sorted = [...refs].sort();
  return { spans: sorted.length > 1, refs: sorted };
}
